
    <template>
      <section class="relax-doc">
        <h1>Radio 单选框</h1>
<blockquote>
<p>有可选项进行单选</p>
</blockquote>
<h2 id="yan-shi"><a class="header-anchor" href="#yan-shi"></a> 演示</h2>
<blockquote>
<p>使用 <code>v-model</code> 双向绑定</p>
</blockquote>
<demo-block>
        
        <template #source><element-demo0 /></template>
        <template #highlight><pre v-pre><code class="html">&lt;template&gt;
  &lt;x-radio label=&quot;one&quot; :value=&quot;1&quot; v-model=&quot;radio&quot; /&gt;
  &lt;x-radio label=&quot;two&quot; :value=&quot;2&quot; v-model=&quot;radio&quot; /&gt;
&lt;/template&gt;
&lt;script&gt;
  import {ref} from 'vue'
  export default {
    setup(){
      const radio = ref(1)

      return {
        radio
      }
    }
  }
&lt;/script&gt;
</code></pre></template></demo-block><h2 id="jin-yong"><a class="header-anchor" href="#jin-yong"></a> 禁用</h2>
<blockquote>
<p>添加 <code>disabled</code> 属性 禁用 <code>radio</code></p>
</blockquote>
<demo-block>
        
        <template #source><element-demo1 /></template>
        <template #highlight><pre v-pre><code class="html">&lt;template&gt;
  &lt;x-radio label=&quot;one&quot; checked /&gt;
  &lt;x-radio label=&quot;two&quot; disabled  /&gt;
  &lt;x-radio label=&quot;three&quot; disabled checked&gt; four &lt;/x-radio&gt;
&lt;/template&gt;
</code></pre></template></demo-block><h2 id="radio-zu"><a class="header-anchor" href="#radio-zu"></a> radio 组</h2>
<blockquote>
<p>添加 <code>disabled</code> 属性 禁用 <code>radio</code></p>
</blockquote>
<demo-block>
        
        <template #source><element-demo2 /></template>
        <template #highlight><pre v-pre><code class="html">&lt;template&gt;
  &lt;x-radio-group v-model=&quot;radio&quot;&gt;
    &lt;x-radio label=&quot;one&quot; value=&quot;1&quot;  /&gt;
    &lt;x-radio label=&quot;two&quot; value=&quot;2&quot;   /&gt;
    &lt;x-radio label=&quot;three&quot; value=&quot;3&quot; disabled&gt; three &lt;/x-radio&gt;
    &lt;x-radio label=&quot;three&quot; value=&quot;4&quot; disabled&gt; three &lt;/x-radio&gt;
  &lt;/x-radio-group&gt;
&lt;/template&gt;
&lt;script&gt;
  import {ref} from 'vue'
  export default {
    setup(){
      const radio = ref('4')

      return {
        radio
      }
    }
  }
&lt;/script&gt;
</code></pre></template></demo-block>
      </section>
    </template>
    <script>
      import hljs from 'highlight.js'
      import * as Vue from "vue"
      export default {
        name: 'component-doc',
        components: {
          "element-demo0": (function() {
    
    const { resolveComponent: _resolveComponent, createVNode: _createVNode, Fragment: _Fragment, openBlock: _openBlock, createElementBlock: _createElementBlock } = Vue

function render (_ctx, _cache) {
  const _component_x_radio = _resolveComponent("x-radio")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_x_radio, {
      label: "one",
      value: 1,
      modelValue: _ctx.radio,
      "onUpdate:modelValue": $event => ((_ctx.radio) = $event)
    }, null, 8, ["modelValue", "onUpdate:modelValue"]),
    _createVNode(_component_x_radio, {
      label: "two",
      value: 2,
      modelValue: _ctx.radio,
      "onUpdate:modelValue": $event => ((_ctx.radio) = $event)
    }, null, 8, ["modelValue", "onUpdate:modelValue"])
  ], 64))
}
  
    
        const {ref} = Vue
        
  const democomponentExport = {
    setup(){
      const radio = ref(1)

      return {
        radio
      }
    }
  }
    return {
      mounted(){
        this.$nextTick(()=>{
          const blocks = document.querySelectorAll('pre code:not(.hljs)')
          Array.prototype.forEach.call(blocks, hljs.highlightBlock)
        })
      },
      render,
      ...democomponentExport
    }
  })(),"element-demo1": (function() {
    
    const { resolveComponent: _resolveComponent, createVNode: _createVNode, createTextVNode: _createTextVNode, withCtx: _withCtx, Fragment: _Fragment, openBlock: _openBlock, createElementBlock: _createElementBlock } = Vue

function render (_ctx, _cache) {
  const _component_x_radio = _resolveComponent("x-radio")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_x_radio, {
      label: "one",
      checked: ""
    }),
    _createVNode(_component_x_radio, {
      label: "two",
      disabled: ""
    }),
    _createVNode(_component_x_radio, {
      label: "three",
      disabled: "",
      checked: ""
    }, {
      default: _withCtx(() => [
        _createTextVNode(" four ")
      ]),
      _: 1
    })
  ], 64))
}
  
    const democomponentExport = {}
    return {
      mounted(){
        this.$nextTick(()=>{
          const blocks = document.querySelectorAll('pre code:not(.hljs)')
          Array.prototype.forEach.call(blocks, hljs.highlightBlock)
        })
      },
      render,
      ...democomponentExport
    }
  })(),"element-demo2": (function() {
    
    const { resolveComponent: _resolveComponent, createVNode: _createVNode, createTextVNode: _createTextVNode, withCtx: _withCtx, openBlock: _openBlock, createBlock: _createBlock } = Vue

function render (_ctx, _cache) {
  const _component_x_radio = _resolveComponent("x-radio")
  const _component_x_radio_group = _resolveComponent("x-radio-group")

  return (_openBlock(), _createBlock(_component_x_radio_group, {
    modelValue: _ctx.radio,
    "onUpdate:modelValue": $event => ((_ctx.radio) = $event)
  }, {
    default: _withCtx(() => [
      _createVNode(_component_x_radio, {
        label: "one",
        value: "1"
      }),
      _createVNode(_component_x_radio, {
        label: "two",
        value: "2"
      }),
      _createVNode(_component_x_radio, {
        label: "three",
        value: "3",
        disabled: ""
      }, {
        default: _withCtx(() => [
          _createTextVNode(" three ")
        ]),
        _: 1
      }),
      _createVNode(_component_x_radio, {
        label: "three",
        value: "4",
        disabled: ""
      }, {
        default: _withCtx(() => [
          _createTextVNode(" three ")
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue", "onUpdate:modelValue"]))
}
  
    
        const {ref} = Vue
        
  const democomponentExport = {
    setup(){
      const radio = ref('4')

      return {
        radio
      }
    }
  }
    return {
      mounted(){
        this.$nextTick(()=>{
          const blocks = document.querySelectorAll('pre code:not(.hljs)')
          Array.prototype.forEach.call(blocks, hljs.highlightBlock)
        })
      },
      render,
      ...democomponentExport
    }
  })(),
        }
      }
    </script>
  